import UrlUtils from '@spothero/utils/url';
import SearchUtils, {getDefaultSearchPageView} from 'utils/search-utils';
import {getAdTrackingParamsAsObject} from 'utils/url-utils';
import {
    loadDataSequence,
    sanitizeSearchRequestResponse,
} from 'store/search-request/search-request-utils';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';

export async function createCleanedData({
    currentCity,
    cleanedParams,
    currentSearchState,
}) {
    const {
        page_info: {page_type: pageType, setup},
    } = cleanedParams;

    const loadedData = await loadDataSequence({
        pageType,
        setup,
        isNewCity: setup.city.slug !== currentCity.data.slug,
    });

    const cleanedData = {
        searchRequest: sanitizeSearchRequestResponse({
            state: {...searchRequestInitialState},
            response: cleanedParams,
        }),
        ...loadedData,
    };

    if (!cleanedData.city) {
        cleanedData.city = currentCity;
    }

    cleanedData.search = SearchUtils.prepareStoreData({
        initData: cleanedData,
        pageType,
        currentSearchState,
    });

    return cleanedData;
}

export function routeToSearch({
    method,
    pageType = 'address',
    id = null,
    queryParams = {},
    historyState = {},
}) {
    // TODO: right now the search-params endpoint returns 'search' instead of 'address' for default page type
    // the new endpoint that replaces search-params should return a better aligned mapping to the page types we are
    // expecting in this method, 'search' should become 'address' and 'venue' should become 'destination'
    // venue determination happens on the FE only, as in, a destination that has events
    const kind =
        pageType === 'venue'
            ? 'destination'
            : pageType === 'search'
            ? 'address'
            : pageType;
    const query = UrlUtils.createQueryString({
        kind,
        // pageType 'address' does not have an associated ID
        ...(id && {id}),
        ...getAdTrackingParamsAsObject(),
        ...queryParams,
    });

    method(`/search?${query}`, historyState);
}

export function routeToSpotDetails({
    method,
    location: {pathname, search},
    spotId,
    historyState = {},
}) {
    const query = UrlUtils.createQueryString({
        ...UrlUtils.parseParams(search),
        // always get the view from the default search page view
        // React-router sometimes is out of sync with the current view
        view: getDefaultSearchPageView(),
        'spot-id': spotId,
    });

    method(`${pathname}?${query}`, {...historyState, reload: false});
}
